import { JSONSchema6 } from "json-schema";

const closeChargePermissionSchema: JSONSchema6 =
{
    title: "Close Charge Permission",
    description: "Moves the Charge Permission to a Closed state. No future charges can be made and pending charges will be canceled if you set cancelPendingCharges to true.",
    properties: {
        "pathParam": {
            title: "chargePermissionId",
            type: "string",
        },
        "payload": {
            type: "object",
            properties: {
                "closureReason": {
                    type: "string",
                    maxLength: 255
                },
                "cancelPendingCharges": {
                    type: "boolean",
                }
            },
            required: ["closureReason"]
        }
    },
    required: ["payload"]
}

export default closeChargePermissionSchema;
